module.exports = __webpack_public_path__ + "img/jp_xhs_2wm.3ad07a6.jpg";